export const SOCKET_EVENTS = {
  PRODUCT_UPDATED: "ProductUpdated",
  SIGNAGE_DATA_INVALIDATED: "SignageDataInvalidated",
  SIGNAGE_ADVERTISEMENT_INVALIDATED: "SignageAdvertisementInvalidated",
  SIGNAGE_TAG_INVALIDATED: "SignageTagInvalidated",
  SIGNAGE_MAKER_INVALIDATED: "SignageMakerInvalidated",
}
